import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Card, Button, Typography, Space } from 'antd';
import {
  ClockCircleOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  RedoOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

function formatTime(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

const MeditationTimer: React.FC = () => {
  const [seconds, setSeconds] = useState(0);
  const [active, setActive] = useState(false);
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (active) {
      intervalRef.current = window.setInterval(() => {
        setSeconds((s) => s + 1);
      }, 1000);
    } else if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }
    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, [active]);

  const handleToggle = useCallback(() => {
    setActive((prev) => !prev);
  }, []);

  const handleReset = useCallback(() => {
    setActive(false);
    setSeconds(0);
  }, []);

  return (
    <Card className="meditation-card" title="Đồng hồ thiền">
      <div className="meditation-container">
        <Space align="center" className="meditation-time-row">
          <ClockCircleOutlined
            className={`meditation-icon${active ? ' rotating' : ''}`}
          />
          <Text className="meditation-time">{formatTime(seconds)}</Text>
        </Space>
        <Text type="secondary" className="meditation-hint">
          Thời gian thiền của bạn
        </Text>
        <Space className="meditation-controls">
          <Button
            type="primary"
            icon={active ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
            onClick={handleToggle}
          >
            {active ? 'Tạm dừng' : 'Bắt đầu'}
          </Button>
          <Button icon={<RedoOutlined />} onClick={handleReset}>
            Đặt lại
          </Button>
        </Space>
      </div>
    </Card>
  );
};

export default MeditationTimer;
